export class BrowserDelay {
    wait(milliseconds) {
        return new Promise((resolve) => globalThis.setTimeout(resolve, milliseconds));
    }
}
//# sourceMappingURL=browser-delay.js.map